module.exports = __webpack_public_path__ + "img/preview-icon.71b70d25.svg";